import React from 'react';
import type { OwaHeaderProps } from 'owa-bootstrap';
import { isCapabilityEnabled } from 'owa-capabilities';
import { novaMeControlCapability } from 'owa-capabilities-definitions/lib/novaMeControlCapability';
import { FluentNovaMeControl, FluentNovaMeControlContainer } from 'owa-fluent-nova-mecontrol';
import { observer } from 'owa-mobx-react';
import OwaHeaderButtonGroup from './buttons/OwaHeaderButtonGroup';
import OwaHeaderBrandingLabel from './charms/OwaHeaderBrandingLabel';
import OwaHeaderDevSourceLabel from './charms/OwaHeaderDevSourceLabel';
import {
    headerLeft,
    headerRight,
    headerCenter,
    headerCharmsAndSearch,
    headerLeftCharms,
    headerSearch,
} from './OwaHeader.scss';
import OwaHeaderBackground from './OwaHeaderBackground';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';

export default observer(function OwaHeader(props: OwaHeaderProps) {
    const wrapSuiteHeader = props.wrapSuiteHeader;
    const novaMeControl = isCapabilityEnabled(novaMeControlCapability)
        ? (FluentNovaMeControl as React.FC<{
              accountKey: string;
          }>)
        : undefined;
    const accountKey = getAccountKeyForMailboxInfo(getModuleContextMailboxInfo());

    const header = (
        <OwaHeaderBackground>
            <div className={headerLeft} />
            <div className={headerCenter}>
                <div className={headerCharmsAndSearch}>
                    <div className={headerLeftCharms}>
                        <OwaHeaderDevSourceLabel />
                        <OwaHeaderBrandingLabel />
                        {props.renderSearchScopePicker?.()}
                    </div>
                    <div className={headerSearch}>{props.renderSearch?.()}</div>
                </div>
                <OwaHeaderButtonGroup />
            </div>
            <div className={headerRight} />
        </OwaHeaderBackground>
    );

    const headerWithMeControl = wrapSuiteHeader ? (
        wrapSuiteHeader(header, novaMeControl)
    ) : novaMeControl ? (
        <FluentNovaMeControlContainer accountKey={accountKey}>
            {header}
        </FluentNovaMeControlContainer>
    ) : (
        header
    );

    return headerWithMeControl;
}, 'OwaHeader');
